import { useQuery } from '@tanstack/react-query';

import { recognitionServices } from '@hero/services';
import { cleanObjectEmptyFields } from '@hero/utils';

export const useGetRecognitionPopularGifts = (params, options) => {
  const {
    filters: { ids },
    pagination: { limit, page }
  } = params;

  return useQuery(
    ['recognitionPopularGifts', page, limit, ids],
    () => {
      return recognitionServices.popularGifts(cleanObjectEmptyFields(params));
    },
    options
  );
};
